import { KycTitle, Layout, ModalView, PageMotion, PoweredBy, ProgressIndicator } from "components";
import { PageProps } from "interfaces";
import { RegistrationForms } from "ui";

interface RegistrationProps extends PageProps {}

export default function Registration(props: RegistrationProps) {
  return (
    <PageMotion key="Registration" px="4px">
      <Layout>
        <ModalView>
          <KycTitle />

          <ProgressIndicator />

          <RegistrationForms {...props} />
        </ModalView>
      </Layout>

      <PoweredBy />
    </PageMotion>
  );
}
